import React, { useEffect, useState } from 'react';
import ProjectCardComponent from '../../../../components/ProjectCard/ProjectCardComponent';
import {
  OutlinedInput,
  InputLabel,
  FormControl,
  Tooltip,
  Grid,
  Typography,
  Icon,
  Box,
  Select,
  MenuItem,
} from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import { SHOW_NOTIFICATION } from '../../../../constants';
import { useDispatch } from 'react-redux';
import PaginationComponent from '../../../../components/Pagination/Pagination';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import {
  getProjectById,
  getProjectsByName,
} from '../../../../services/ProjectService';
import IconButton from '@mui/material/IconButton';
import './ManageProjectComponent.css';
import GenericLoader from '../../../../components/Loader/GenericLoader';
import AddProjectComponent from './AddProjectComponent';
import {
  NO_PROJECTS,
  SEARCH_BY,
  SEARCH_BY_OPTIONS,
  SearchByLabel,
  SearchEmployee,
  SearchProject,
} from '../ManageConstants';
import { ManageLoaderAttribute } from '../../../../constants';

const ManageProjectsComponent = (props) => {
  const [userMappedProjects, setUserMappedProjects] = React.useState([]);
  const [allProjects, setAllProjects] = useState([]);
  const emptyProject = {
    name: '',
    description: '',
    startDate: new Date(),
    PId: '',
  };
  const [project, setProject] = React.useState({
    name: '',
    description: '',
    startDate: new Date(),
    PId: '',
  });
  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };
  const dispatch = useDispatch();
  const resetProject = () => {
    setProject(emptyProject);
  };
  const [loader, setLoader] = React.useState(false);
  const [editable, setEditable] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchBy, setSearchBy] = useState(SEARCH_BY.PROJECT_NAME);
  const [isSearched, setIssearched] = useState(false);
  const [pageSize, setPageSize] = useState(3);
  const [totalPage, setTotalPage] = React.useState();
  const [pageNo, setPageNo] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const pageChange = async (event, value) => {
    setPage(value);
    const projects = await getProjectsByName(
      searchTerm,
      value - 1,
      pageSize,
      searchBy,
    );
    setUserMappedProjects((prevProjects) => [...projects.data.content]);
    dipatchNotification(projects.type, projects.message);
  };

  const handlePageSizeChange = async (event) => {
    const newPageSize = event.target.value;
    setPageSize(newPageSize);
    setPage(1);
    setLoader(true);
    const projects = await getProjectsByName(
      searchTerm,
      0,
      newPageSize,
      searchBy,
    );
    setLoader(false);
    setUserMappedProjects((prevProjects) => [...projects.data.content]);
    setTotalPage(projects.data.totalPages);
    dipatchNotification(projects.type, projects.message);
  };

  const loadData = async () => {
    const projects = await getProjectsByName('', pageNo, pageSize, searchBy);
    setUserMappedProjects((prevProjects) => [...projects.data.content]);
    setTotalPage(projects.data.totalPages);
    if (projects?.data?.numberOfElements === 0) {
      setPageNo(0);
      setPage(1);
    }
    dipatchNotification(projects.type, projects.message);
  };

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };
  const clearField = () => {
    setSearchTerm('');
    searchProjectByName('', searchBy);
  };
  const getProjects = async (pName, searchMode) => {
    setPageNo(0);
    setPage(1);
    const projectList = await getProjectsByName(
      pName,
      pageNo,
      pageSize,
      searchMode,
    );
    if (projectList?.status === 200) {
      setUserMappedProjects((prevProjects) => [...projectList.data.content]);
      setTotalPage(projectList.data.totalPages);
      if (projectList?.data?.numberOfElements === 0) {
        setPageNo(0);
        setPage(1);
      }
    } else {
      setUserMappedProjects((prevProjects) => []);
      setPageNo(0);
      setPage(1);
    }
    dipatchNotification(projectList.type, projectList.message);
    setLoader(false);
  };

  const searchProjectByName = React.useCallback(debounce(getProjects), []);

  useEffect(() => {
    loadData();
  }, []);

  const getProjectsById = async (id) => {
    const toEditProject = await getProjectById(id, '', '');
    setProject({
      name: toEditProject.data.content[0].projectName,
      description: toEditProject.data.content[0].description,
      startDate: new Date(toEditProject.data.content[0].startDate),
      pId: id,
    });
    setEditable(true);
    dipatchNotification(toEditProject.type, toEditProject.message);
  };

  const fetchAllProjects = async () => {
    let allFetchedProjectNames = [];
    let currentPage = 0;

    while (true) {
      const projects = await getProjectsByName('');
      const projectNames = projects.data.content.map(
        (project) => project.projectName,
      ); // Extract projectName
      allFetchedProjectNames = [...allFetchedProjectNames, ...projectNames];

      if (currentPage >= projects.data.totalPages - 1) {
        break;
      }
      currentPage++;
    }

    setAllProjects(allFetchedProjectNames);
    dipatchNotification('success', 'All projects loaded successfully');
  };

  useEffect(() => {
    fetchAllProjects();
  }, []);

  const searchInputLabel =
    searchBy === SEARCH_BY.EMPLOYEE_NAME ? SearchEmployee : SearchProject;

  return (
    <div>
      {loader ? (
        <div>
          <GenericLoader rectAttributes={ManageLoaderAttribute} />
        </div>
      ) : (
        <div>
          <AddProjectComponent
            loadData={loadData}
            project={project}
            expanded={expanded}
            setExpanded={setExpanded}
            editable={editable}
            setEditable={setEditable}
            userMappedProjects={userMappedProjects}
            resetProject={resetProject}
            setPage={setPage}
            allProjects={allProjects}
          />
          <div className="project-search-bar">
            {userMappedProjects.length != 0 || isSearched ? (
              <>
                <FormControl
                  className="project-search-by"
                  size="small"
                  variant="outlined"
                >
                  <InputLabel id="search-by-label">{SearchByLabel}</InputLabel>
                  <Select
                    labelId="search-by-label"
                    id="search-by"
                    value={searchBy}
                    label={SearchByLabel}
                    onChange={(e) => {
                      const mode = e.target.value;
                      setSearchBy(mode);
                      setIssearched(true);
                      setSearchTerm('');
                      searchProjectByName('', mode);
                    }}
                  >
                    {SEARCH_BY_OPTIONS.map((option) => (
                      <MenuItem value={option.value} key={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <div className="project-search-input">
                  <FormControl sx={{ width: '100%' }} variant="outlined">
                    <InputLabel
                      size="small"
                      htmlFor="outlined-adornment-Project"
                    >
                      {searchInputLabel}
                    </InputLabel>

                    <OutlinedInput
                      id="outlined-adornment-Project"
                      type="text"
                      size="small"
                      onChange={(e) => {
                        setIssearched(true);
                        setSearchTerm(e.target.value);
                        searchProjectByName(e.target.value.trim(), searchBy);
                      }}
                      value={searchTerm}
                      endAdornment={
                        <InputAdornment position="end">
                          {searchTerm != '' && (
                            <IconButton
                              onClick={clearField}
                              edge="end"
                              size="small"
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          )}
                        </InputAdornment>
                      }
                      label={searchInputLabel}
                    />
                  </FormControl>
                </div>
                <Tooltip title="Search" arrow>
                  <Icon sx={{ width: '1.25em', height: '1.25em' }}>
                    <SearchIcon />
                  </Icon>
                </Tooltip>
              </>
            ) : (
              ''
            )}
          </div>
          {userMappedProjects.length != 0 ? (
            userMappedProjects.map((project, index) => {
              return (
                <ProjectCardComponent
                  setPage={setPage}
                  setExpand={setExpanded}
                  expand={expanded}
                  project={project}
                  key={project.id}
                  getProjectsById={getProjectsById}
                  reloadProjects={loadData}
                  searchedEmployee={searchBy === SEARCH_BY.EMPLOYEE_NAME ? searchTerm : ''}
                />
              );
            })
          ) : (
            <Grid
              container
              item
              md={3}
              xs={3}
              sx={{ height: '350px', m: 'auto' }}
            >
              <Typography sx={{ mt: 'auto', mb: 'auto' }}>
                {NO_PROJECTS}
              </Typography>
            </Grid>
          )}

          <Box
            className="page-holder"
            sx={{ marginTop: '12px', marginBottom: '9px' }}
          >
            {userMappedProjects.length !== 0 && (
              <PaginationComponent
                count={totalPage}
                page={page}
                pageChange={pageChange}
                pageSize={pageSize}
                handlePageSizeChange={handlePageSizeChange}
              />
            )}
          </Box>
        </div>
      )}
    </div>
  );
};

export default ManageProjectsComponent;
